import "./AddPartnerUser.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddPartnerUserComponentController from "./AddPartnerUserComponentController";

export default class AddPartnerUserComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddPartnerUserComponentController;
        this.templateUrl = "/App/Components/Partners/Details/AddPartnerUser/AddPartnerUser.html";
    }
}

module("mmManagePortal").component("irAddPartnerUser", new AddPartnerUserComponent());
